import { WhitelistedAddresses } from "@cede/types";

export const mockedWhitelistedAddresses: WhitelistedAddresses[] = [
  {
    address: "0x000000000000000000000000000000000000000",
    key: "Null Address",
    network: "ethereum",
    tokenSymbol: "ETH",
    verified: true,
  },
];
